import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { MultimediaManagerDialogLayoutService } from './multimedia-manager-dialog-layout.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { MatDialogRef } from '@angular/material/dialog';
import { MultimediaManagerComponent } from '../multimedia-manager/multimedia-manager.component';
import { MultimediaManagerDialogService } from '../multimedia-manager-dialog/multimedia-manager-dialog.service';
import { MultimediaManagerDialogItem, MultimediaManagerDialogItemTypes } from '../multimedia-manager-dialog/multimedia-manager-dialog-item.model';
import { MultimediaManagerDialogItemFolderComponent } from '../multimedia-manager-dialog-item-folder/multimedia-manager-dialog-item-folder.component';
import { MultimediaManagerDialogSidenavFolder } from '../multimedia-manager-dialog-sidenav/multimedia-manager-dialog-sidenav-folder.model';
import { MultimediaManagerDialogUploaderService } from '../multimedia-manager-dialog-uploader/multimedia-manager-dialog-uploader.service';
import { Mode } from '../multimedia-manager-dialog/multimedia-manager-dialog.component';

@Component({
  selector: 'app-multimedia-manager-dialog-layout',
  templateUrl: './multimedia-manager-dialog-layout.component.html',
  styleUrls: ['./multimedia-manager-dialog-layout.component.scss']
})
export class MultimediaManagerDialogLayoutComponent implements OnInit, OnDestroy {

  items;
  currentFolder;
  currentFatherFolder;
  multiOption: boolean;
  waitingConfig;
  downloads;
  getItemsSubscription: Subscription;
  listenFolderChangedSubscription: Subscription;
  deleteItemSubscription: Subscription;
  listenPercentSubscription: Subscription;

  constructor(private dialog: MatDialogRef<MultimediaManagerComponent>,
              private multimediaManagerDialogService: MultimediaManagerDialogService,
              private multimediaManagerDialogLayoutService: MultimediaManagerDialogLayoutService,
              private multimediaManagerDialogUploaderService: MultimediaManagerDialogUploaderService,
              private snackbarService: SnackBarService) {
                this.waitingConfig = this.setWaitingConfig();
                this.downloads = [];
              }

  ngOnInit() {
    this.multiOption = this.multimediaManagerDialogService.getMultiOption();
    this.listenFolderChangedSubscription = this.multimediaManagerDialogService.listenFolderChanged().subscribe(
      (res) => {
        this.items = res.items;
        this.currentFolder = res.currentFolder;
        this.currentFatherFolder = res.currentFatherFolder;
      }
    );
    this.listenPercentSubscription = this.multimediaManagerDialogUploaderService.listen_percent().subscribe(
      (res) => {
        const i = this.downloads.findIndex(e => e.fileName === res['fileName']);
        if (i !== -1) {
          this.downloads[i] = res;
        } else {
          this.downloads.push(res);
        }
      }
    );
  }

  public selectedItems() {
    if (this.items && this.items.length > 0) {
      return this.items.filter(i => i.Selected).length;
    }
    return 0;
  }

  public up() {
    if (this.currentFatherFolder.FatherFolderInternalId) {
      this.multimediaManagerDialogService.folderChanged(this.currentFatherFolder);
    }
  }


  public drop(e, destiny) {
    this._moveTo(this._getSelectedItems(), destiny.InternalId);
  }

  private _moveTo(items, destinyFolderId) {
    const elements = [];
    items.forEach( (i) => elements.push({ 'type': i.Type, 'internalId': i.InternalId }) );
    this.multimediaManagerDialogLayoutService.moveElements(elements, destinyFolderId, this.currentFolder.InternalId).subscribe(
      (folders) => {
        this.multimediaManagerDialogService.folderChanged(this.currentFolder);
      },
      (error) => {
        this.snackbarService.open('error', error);
      }
    );
  }

  public allowdrop(e, item) {
    if (item.Type === MultimediaManagerDialogItemTypes.FOLDER) { event.preventDefault(); }
  }

  public select(o) {
    if (this.items && this.items.length > 0) {
      switch (o) {
        case 'all':
          this.items.map(i => i.Selected = true);
          break;
        case 'none':
          this.items.map(i => i.Selected = false);
          break;
      }
    }
  }

  private _getSelectedItems() {
    if (this.items && this.items.length > 0) {
      return this.items.filter(i => i.Selected && (i.Type !== 'FOLDER'));
    }
  }

  public insert() {
    if (!this.multimediaManagerDialogService.getEditorOption()) {
      this.dialog.close(this._getSelectedItems());
    }
  }

  public deleteItems() {
    this.deleteItemSubscription = this.multimediaManagerDialogLayoutService.deleteItem(this._getSelectedItems()).subscribe(
      (res) => {
        this.multimediaManagerDialogService.folderChanged(this.currentFolder);
      },
      (error) => {
        this.snackbarService.open('error', error);
      }
    );
  }

  public goHome() {
    this.multimediaManagerDialogService.goHome();
  }

  public addFolder() {
    const folder = {
      data: null,
      name: 'Carpeta nueva',
      type: MultimediaManagerDialogItemTypes.FOLDER,
      destinyFolderId: this.currentFolder.InternalId,
    };
    this.multimediaManagerDialogLayoutService.saveElement(folder).subscribe(
      (folders) => {
        this.multimediaManagerDialogService.folderChanged(this.currentFolder);
      },
      (error) => {
        this.snackbarService.open('error', error);
      }
    );
  }

  private setWaitingConfig() {
    return {
        path: 'assets/lottie-animations/waiting-glasses.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
    };
  }

  ngOnDestroy() {
    if (this.getItemsSubscription) { this.getItemsSubscription.unsubscribe(); }
    if (this.listenFolderChangedSubscription) { this.listenFolderChangedSubscription.unsubscribe(); }
    if (this.listenPercentSubscription) { this.listenPercentSubscription.unsubscribe(); }
  }
}
